import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { onboardTeacher } from "./onboard-teacher";

const initialState: ProcessingState = { processing: "idle" };

export const resetOnboardTeacher = createAction("users/resetOnboardTeacher");

export const onboardTeacherReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(onboardTeacher.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(onboardTeacher.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(onboardTeacher.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetOnboardTeacher, () => {
    return initialState;
  });
});
